import { render, staticRenderFns } from "./exemptedCustomers.vue?vue&type=template&id=5eb64b47&scoped=true&"
import script from "./exemptedCustomers.vue?vue&type=script&lang=js&"
export * from "./exemptedCustomers.vue?vue&type=script&lang=js&"
import style0 from "./exemptedCustomers.vue?vue&type=style&index=0&id=5eb64b47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb64b47",
  null
  
)

export default component.exports